var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"deceased-icon hint--bottom",attrs:{"aria-label":_vm.$t('patient.deceased_at_tooltip', {date: _vm.date})}},[_c('span',{staticClass:"deceased-icon__inner"})])}
var staticRenderFns = []

export { render, staticRenderFns }